import { motion } from "framer-motion";

const works = [
  { img: "/images/lavori-natural-mente.jpg", label: "Insegna da Interno", title: "Natural Mente", tall: true },
  { img: "/images/lavori-evasion-mixology.jpg", label: "Insegne Luminose", title: "Evasion Dinner · Mixology Music" },
  { img: "/images/lavori-molino48.jpg", label: "Vetrofanie", title: "Molino 48 · Zampieri" },
  { img: "/images/lavori-prima-si.jpg", label: "Decorazione Automezzi", title: "Prima S.I. Facility Management" },
  { img: "/images/lavori-molteni.jpg", label: "Insegna e Vetrofanie", title: "Molteni Renzo Arredamenti" },
  { img: "/images/lavori-hidroconta.jpg", label: "Allestimento Fieristico", title: "Hidroconta Metering Technology", tall: true },
  { img: "/images/lavori-ark.jpg", label: "Allestimento Fieristico", title: "ARK Smart Technologies" },
  { img: "/images/lavori-centrale.jpg", label: "Insegna e Vetrofania", title: "Centrale · Dottori Molgaro" },
  { img: "/images/lavori-premium.jpg", label: "Insegna Luminosa", title: "Premium Real Estate" },
  { img: "/images/lavori-qicasa.jpg", label: "Insegne per Showroom", title: "QiCasa · Arredo3" },
  { img: "/images/lavori-vodafone.jpg", label: "Insegne e Grafica Grande Formato", title: "Vodafone · Centro Torri" },
  { img: "/images/lavori-affaritaliani.jpg", label: "Lettere 3D da Interno", title: "Affaritaliani", tall: true },
  { img: "/images/lavori-edilcasa.jpg", label: "Decorazione Automezzi", title: "Edilcasa S.r.l.s." },
  { img: "/images/lavori-dolomiti.jpg", label: "Pannelli e Stampa", title: "Dolomiti Energia" },
  { img: "/images/lavori-lettere-marchio.jpg", label: "Lettere 3D da Interno", title: "Parete Marchi · Showroom" },
  { img: "/images/lavori-dolomiti-negozio.jpg", label: "Insegna e Vetrofanie", title: "Dolomiti Energia · Negozio" },
  { img: "/images/lavori-chemma.jpg", label: "Insegna per Ingresso Aziendale", title: "Chemma Lubrotech" },
  { img: "/images/lavori-vodafone-vetrofanie.jpg", label: "Vetrofanie Promozionali", title: "Vodafone · Giganetwork", tall: true },
  { img: "/images/lavori-mac.jpg", label: "Allestimento Punto Vendita", title: "M·A·C Cosmetics" },
  { img: "/images/lavori-vivo-mediaworld.jpg", label: "Grafica Grande Formato", title: "Vivo · MediaWorld" },
];

export const Portfolio = () => (
  <section id="lavori" className="py-24 lg:py-32" data-testid="portfolio-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="mb-14">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-xs tracking-[0.35em] uppercase text-zinc-500 mb-6"
        >
          I Nostri Lavori
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display font-semibold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl text-zinc-900"
          style={{ wordSpacing: "0.12em" }}
          data-testid="portfolio-title"
        >
          Le immagini parlano.<br /><span className="text-gradient">Noi le facciamo grandi.</span>
        </motion.h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="portfolio-grid">
        {works.map((w, i) => (
          <motion.figure
            key={w.title}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative overflow-hidden rounded-2xl border border-zinc-200 ${w.tall ? "sm:row-span-2 h-[420px] sm:h-full" : "h-[300px]"}`}
            data-testid={`work-card-${i}`}
          >
            <img src={w.img} alt={w.title} loading="lazy"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-70 group-hover:opacity-100 transition-opacity duration-500" />
            <figcaption className="absolute bottom-0 left-0 right-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
              <span className="text-[10px] tracking-[0.3em] uppercase text-[#00E5FF]">{w.label}</span>
              <p className="font-display font-medium text-lg mt-1 text-white">{w.title}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
